import { client,request } from "./api";

export async function getData(req="") {
  const res = await client.get("formation/getFormations?"+req);
  if(res.data && res.data.data && res.data.data.length > 0){
  return res.data.data;
  }else{
    return [];
  }
}

export async function getPaginateData(page,limit,req="") {
  const res = await request.get(`formation/getPaginateFormation?page=${page}&limit=${limit}&${req}`);
  if(res.data){
  return res.data;
  }else{
    return [];
  }
}

export async function getThematics() {
  const res = await request.get(`formation/getThematics`);
  if(res.data){
  return res.data;
      console.log(res.data)
  }else{
    return [];
  }
}
